import { defineStore } from "pinia";

const STATUS_COLORS = {
  signed: {
    background: "#d1fae5",
    color: "#065f46",
    borderColor: "#a7f3d0",
  },
  draft: {
    background: "#fef3c7",
    color: "#92400e",
    borderColor: "#fde68a",
  },
  rejected: {
    background: "#fee2e2",
    color: "#991b1b",
    borderColor: "#fecaca",
  },
  pending: {
    background: "#dbeafe",
    color: "#1e40af",
    borderColor: "#bfdbfe",
  },
  neutral: {
    background: "#f3f4f6",
    color: "#374151",
    borderColor: "#e5e7eb",
  },
};

export const useEdoDocumentStatusStore = defineStore("edoDocumentStatus", {
  state: () => ({
    colors: STATUS_COLORS,
  }),

  actions: {
    // Определяет смысловую группу статуса по тексту от backend/Saby
    statusKind(status) {
      if (!status) return "neutral";

      const value = status.toLowerCase();
      if (value.includes("подписан") || value.includes("завершён")) {
        return "signed";
      }
      if (value.includes("черновик") || value.includes("создан")) {
        return "draft";
      }
      if (value.includes("отклонён") || value.includes("аннулирован")) {
        return "rejected";
      }
      if (
        value.includes("ожида") ||
        value.includes("отправлен")
      ) {
        return "pending";
      }

      return "neutral";
    },

    // Возвращает CSS-класс для совместимости с существующими бейджами
    statusClass(status) {
      return `status--${this.statusKind(status)}`;
    },

    // Возвращает цвета бейджа статуса из единого источника
    statusStyle(status) {
      return this.colors[this.statusKind(status)] || this.colors.neutral;
    },

    // Возвращает подсказку: что означает статус и что делать дальше
    statusTooltip(status) {
      const statusText = status || "Статус не указан";

      const messages = {
        signed: "Документ подписан или завершён. Дополнительных действий обычно не требуется",
        draft: "Документ создан, но ещё не завершён. Откройте документ в Saby и проверьте следующий шаг",
        rejected: "Документ отклонён или аннулирован. Проверьте причину в Saby и создайте новый документ при необходимости",
        pending: "Документ ожидает действия или отправлен контрагенту. Проверьте статус в Saby и обновите документ позже",
        neutral: "Статус получен из Saby без отдельного правила. Откройте документ в Saby для деталей",
      };

      return `${statusText}. ${messages[this.statusKind(status)]}`;
    },
  },
});
